/**
 * indexVideoStore
 */
import Vue from 'vue';
import * as types from '../mutation-types';
import * as urls from '../../config/urls';
import auth from '../../utils/auth';

const LATAESTVIDEOLIST_DOWN = 'LATAESTVIDEOLIST_DOWN'; // 最新视频列表
const PLAYRANKINGLIST_DOWN = 'PLAYRANKINGLIST_DOWN'; // 播放排行

const HOTVIDEOLIST_DOWN = 'HOTVIDEOLIST_DOWN'; // 热点视频

const BANNERLIST = 'BANNERLIST';
export default {
    namespaced: true,

    state: {
        // indexVideo
        indexVideoList: [],
        bannerImgList: [], // 轮播图
        latestVideoList: [], // 最新视频列表
        playRankingLIst: [], // 播放排行
        hotVideoList: [], // 热点视频
        indexVideoLoading: false,
        indexVideoExtra: { total: 0 },
        indexVideoQueries: { pagination: 1, pageSize: 20 },
        indexVideoDetail: {},
        bannerList: [],
    },

    mutations: {
        [types.UPDATE_LIST](state, { subject, list }) {
            state[`${subject}List`] = list;
        },
        [types.UPDATE_LOADING_STATUS](state, { subject, isLoading }) {
            state[`${subject}Loading`] = isLoading;
        },
        // 最新播放列表//播放排行//热点视频//轮播图
        [LATAESTVIDEOLIST_DOWN](state, { list }) {
            state.latestVideoList = list;
        },
        [PLAYRANKINGLIST_DOWN](state, { list }) {
            state.playRankingLIst = list;
        },
        [HOTVIDEOLIST_DOWN](state, { list }) {
            state.hotVideoList = list;
        },

        [BANNERLIST](state, { list }) {
            state.bannerList = list;
        },
    },

    actions: {

        //  获取最新视频
        getLatestVideoLIst({ commit, state }, queries = {}) {
            const subject = 'indexVideo';
            const {
                pagination = state[`${subject}Queries`].pagination,
                    pageSize = state[`${subject}Queries`].pageSize,
                    ...otherQueries
            } = queries;
            let urlUse = urls.VIODE_LIST_LOGIN;

            const userId = auth.getUserInfo().user_id;
            console.log(userId);
            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {
                    params: {

                        pageNumber: pageSize,
                        offset: (pagination - 1) * pageSize,
                        userId,
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.rows || {};

                    commit(LATAESTVIDEOLIST_DOWN, { list });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },


        //  获取热播列表
        getHotVideoList({ commit, state }, queries) {
            const subject = 'indexVideo';


            const {
                pagination = state[`${subject}Queries`].pagination,
                    pageSize = state[`${subject}Queries`].pageSize,
                    ...otherQueries
            } = queries;
            let urlUse = urls.VIODE_LIST_LOGIN;

            const userId = auth.getUserInfo().user_id;
            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {
                    params: {
                        pageNumber: pageSize,
                        userId,
                        offset: (pagination - 1) * pageSize,
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.rows || {};
                    commit(HOTVIDEOLIST_DOWN, { list });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },


        getBannerList({ commit }, queries) {
            const {
                ...otherQueries
            } = queries;
            let urlUse = '';

            urlUse = urls.BANNER_LIST;


            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse).then((response) => {
                    const list = response.data || {};
                    commit(BANNERLIST, { list });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
    },
};